import React, {  useEffect, useCallback} from 'react';  
import { useTranslation } from "react-i18next" 
import { useNavigate } from 'react-router-dom'; 
import Box from '@mui/material/Box'; 
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import Textarea from '@mui/joy/Textarea'; 
import "css/generalSettings.css";
import "css/customDialog.css";  
import PropTypes from 'prop-types';
 

const IncidentEmailView = ({ openViewRow,setOpenViewRow,rowEdit}) => {
  const {t,i18n} = useTranslation(['listDataGeneralSettings']); 
  const navigate = useNavigate(); 

  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && openViewRow) {
        setOpenViewRow(false);
      }
    },
    [
      setOpenViewRow,  
      openViewRow
    ]
  );

  const closeModalSentEmailEdit = () => {
    setOpenViewRow(false); 
    navigate("/incidentemail");
  }; 

  const toggleDrawerEmail = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown' ) {
      closeModalSentEmailEdit();
      return;
    }
  };   
    
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
 
  return (
    <div> 
      {openViewRow && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerEmail(false)}
            onOpen={toggleDrawerEmail(true)}
          >
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '1050px' }}>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                    <i className="fas fa-solid fa-inbox text-warning"></i> {t('Text_SENDINCIDENT_Email')}
                  </h1>
                  <div> 
                    <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalSentEmailEdit} >
                      {t('Button_Back')}
                    </button> 
                  </div> 
                </div>   
                <h1 className="h1NewStyle mb-2">{rowEdit.emailto}</h1>

                <div className="email-card-form">
                  <div className="form-group">
                    <div className="row p-4"> 
                      <label className="text-primary">{t('Text_SENDINCIDENT_SUBJECT').toUpperCase()}</label>
                      &nbsp;&nbsp;&nbsp;&nbsp; 
                      <TextField
                        id="subjectEmail" 
                        name="subjectEmail"
                        value={rowEdit.subjectEmail}
                        inputProps={{ style: { width: i18n.language === "es" ? 894 : 888, fontSize: '18px' }, maxLength: 100}}
                        InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                        placeholder={t('Text_SENDINCIDENT_SUBJECT')}
                        variant="standard"
                        disabled>
                      </TextField>
                    </div>
                    <div className="row p-4"> 
                      <label className="text-primary">{t('Text_SENDEMAIL_InicidentType').toUpperCase()}</label>
                      &nbsp;&nbsp;&nbsp;&nbsp; 
                      <TextField
                        id="incidenttype_namees" 
                        name="incidenttype_namees"
                        value={i18n.language==='es'?rowEdit.incidenttype_namees:rowEdit.incidenttype_nameen}
                        inputProps={{ style: { width: i18n.language === "es" ? 711 : 739, fontSize: '18px' }, maxLength: 100}}
                        placeholder={t('Text_SENDEMAIL_InicidentType')}
                        variant="standard"
                        disabled>
                      </TextField>
                    </div>
                    <div className="row p-4"> 
                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SENDEMAIL_Content').toUpperCase()} :</label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <Textarea
                        id="contentEmail"
                        name="contentEmail"
                        value={rowEdit.contentEmail}
                        label={t('PlaceHolder_SENDEMAIL_Content')}
                        placeholder={t('PlaceHolder_SENDEMAIL_Content')}
                        sx={{ width: i18n.language === "es" ? 852 : 873, fontSize: '18px' }}
                        variant="standard" 
                        minRows={8}
                        maxRows={8}
                        disabled
                      />
                    </div>
                      
                    {/* Tipo de Resolución */}
                    <div className="row p-4"> 
                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SENDINCIDENT_RESOLUTIONTYPES').toUpperCase()} :</label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                     &nbsp;&nbsp;&nbsp;&nbsp; 
                      <TextField
                        id="resolution_namees" 
                        name="resolution_namees"
                        value={i18n.language==='es'?rowEdit.resolution_namees:rowEdit.resolution_nameen}
                        inputProps={{ style: { width: i18n.language === "es" ? 748 : 745, fontSize: '18px' }, maxLength: 100}}
                        placeholder={t('Text_SENDINCIDENT_RESOLUTIONTYPES')}
                        variant="standard"
                        disabled>
                      </TextField> 
                    </div>  
                    <div className="row p-4"> 
                      <label className="text-primary">{t('Text_SENDEMAIL_Resolution')} :</label>
                      &nbsp;&nbsp;&nbsp;&nbsp;   
                      <Textarea 
                        id="resolution" 
                        name="resolution"
                        value={rowEdit.resolution}
                        label={t('Text_SENDEMAIL_Resolution')}
                        placeholder={t('Text_SENDEMAIL_Resolution')}
                        sx={{ width: i18n.language === "es" ? 855 : 857, fontSize: '18px' }}
                        variant="standard" 
                        minRows={8}
                        maxRows={8}
                        disabled
                      />  
                    </div> 
                    <div className="row p-4"> 
                      <Checkbox
                        id="hasbeenread" 
                        name="hasbeenread"
                        variant="standard"
                        sx={{
                          '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                        }}
                        disabled
                      />
                      &nbsp;&nbsp;    
                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SENDINCIDENT_READ')}</label>  
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   
                      <Checkbox
                        id="isfinished" 
                        name="isfinished"
                        variant="standard"
                        sx={{
                          '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                        }}
                        disabled
                      />
                      &nbsp;&nbsp;    
                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SENDINCIDENT_END')}</label>  
                    </div>                           
                  </div>  
                </div> 
              </Box>
            </Container>
          </SwipeableDrawer>  
        </div>
      } 
    </div>
  )
}

IncidentEmailView.propTypes = {
  openViewRow: PropTypes.bool.isRequired,
  setOpenViewRow: PropTypes.func.isRequired
};
  
export default IncidentEmailView;

